export class BehaviorClass {
    constructor(
        public type: string,
        public name: string
    ) {}
    
    public $type: string = "Stateflows.BehaviorClass, Stateflows.Common";
}